export const createAcceptanceSummary = (
  acceptedCount,
  totalCount,
  options = {}
) => {
  const { title = 'Принято помещений' } = options;

  return acceptedCount === undefined && totalCount === undefined
    ? undefined
    : `${title}: ${withFallback(acceptedCount)}/${withFallback(totalCount)}`;
};

export const createAcceptanceSlug = (...args) => args.filter(Boolean).join('-');

const indexToKey = { 0: 'acceptanceId', 1: 'houseId' };
export const parseAcceptanceSlug = (param) => {
  const trimmed = typeof param === 'string' ? param.trim() : '';
  const arr = trimmed ? trimmed.split('-') : [];

  return arr.reduce((acc, el, index) => {
    if (indexToKey[index]) {
      const num = Number(el);
      acc[indexToKey[index]] = !isNaN(num) && num > 0 ? num : undefined;
    }

    return acc;
  }, {});
};

export const parsedAcceptanceSlugsIsEqual = (slug1, slug2) => {
  return (
    slug1?.acceptanceId === slug2?.acceptanceId &&
    slug1?.houseId === slug2?.houseId
  );
};

function withFallback(value) {
  return value ?? 'Нет данных';
}
